import { PROJECT_PDF_POSTFIX } from 'const';

export function getProjectPdfName(projectName: string): string {
  return `${projectName}${PROJECT_PDF_POSTFIX}`;
}
